module.exports = __webpack_public_path__ + "media/src/images/logo-92e080a92a8ce86f94d88e4c32793f3e.svg";